import styled from 'styled-components'
import { mildBlue, blue, softBlue } from '../../styles/variables.js'

const Slider = styled.div`
  min-width: 350px;
  height: 65px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  &.readOnly {
    opacity: 0.7;
  }
`

const SliderTrack = styled.div`
  border-radius: 18px;
  height: 16px;
  border: 2px solid ${mildBlue};
  position: relative;
  background: ${softBlue};
  cursor: pointer;
`

const SliderProgress = styled.div`
  background: ${blue};
  border-radius: 18px;
  position: absolute;
  top: -1px;
  bottom: -1px;
  left: -1px;
  cursor: pointer;
`

const ValueIndicator = styled.div`
  position: absolute;
  width: 35px;
  text-align: center;
  right: -25px;
  top: -45px;
  border-radius: 12px;
  padding: 8px 10px;
  border: 2px solid ${mildBlue};
  background: ${softBlue};
  color: ${blue};
  cursor: pointer;
  user-select: none;
  font-size: 14px;

  &::after {
    content: " ";
    position: absolute;
    top: 31px;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: ${softBlue} transparent transparent transparent;
  }

  &::before {
    content: " ";
    position: absolute;
    top: 34px;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: ${mildBlue} transparent transparent transparent;
  }

  &.moving {
    transition: all .1s ease-in-out;
    transform: scale(1.1);
  }

  &.correctLeft {
    right: -30px;
  }
`

export default {
  Slider,
  SliderTrack,
  SliderProgress,
  ValueIndicator,
}
